import { createModel } from '@rematch/core';
import { RootModel } from '../index';
import produce from 'immer';
import { ChainId } from '../../../types/mod';
export interface TransactionsState {
    control: TransactionsControl;
    currentTab: string;
}
export interface SearchKeys {
    address: string,
    pool: string,
    token: string,
    timeStart: any,
    timeEnd: any,
    withContract: string,
    chainId:ChainId,
}

export interface TransactionsControl {
    searchKeys: SearchKeys;
    historySearchKeys:HistorySearchKeys[];

}
export interface TransactionData {
    address?: string;
    pool?: string;
    token?: string;
    timeStart?: string;
    timeEnd?: string;
}
export interface HistorySearchKeys {
    alias:string;
    searchKeys: SearchKeys;
}

export const transaction = createModel<RootModel>()({
    state: {
        TransactionData: {},
        control: {
            searchKeys: { address: '', pool: '', token: '', timeStart: '', timeEnd: '', withContract: '',chainId:ChainId.VirtualAll },
            historySearchKeys:[]as HistorySearchKeys[],
        },
        currentTab: '',
    } as TransactionsState,
    reducers: {
        setControl: (state: TransactionsState, control: TransactionsControl) => produce(state, draft => {
            draft.control = { ...control };
        }),
        setSearchKey: (state: TransactionsState, key: SearchKeys) => produce(state, draft => {
            draft.control.searchKeys = key;
        }),
        seCurrentTab: (state: TransactionsState, value: string) => produce(state, draft => {
            draft.currentTab = value;
        }),
        setHistorySearchKeys: (state: TransactionsState, key: HistorySearchKeys[]) => produce(state, draft => {
            draft.control.historySearchKeys = key;
        }),
        removeHistorySearchKey: (state: TransactionsState, alias: string) => produce(state, draft => {
            draft.control.historySearchKeys.splice(state.control.historySearchKeys.findIndex((e)=>e.alias===alias),1);
        }),
    },
});
